import script from "./AutorizationBodyFormClave.vue?vue&type=script&setup=true&lang=js"
export * from "./AutorizationBodyFormClave.vue?vue&type=script&setup=true&lang=js"

import "./AutorizationBodyFormClave.vue?vue&type=style&index=0&id=b75af27c&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b75af27c"]])

export default __exports__